import { IMAGE_CONFIG, IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import { ImageOptimisePreset, PLACEHOLDER_IMAGES } from '@rma/generic/core/images';
import { appendToRmaStaticImageUrl } from '@rma/generic/ng/util';
import { ImageOptimiseService } from '../image-optimise-service/image-optimise.service';

const imageUrlFactory = (imageUrl: (path: string) => string, optimiseService: ImageOptimiseService) => {
  return (config: ImageLoaderConfig) => {
    if (PLACEHOLDER_IMAGES.includes(config.src)) {
      return imageUrl(config.src);
    }

    if (config.loaderParams?.['type'] === 'staticImage') {
      if (config.width) {
        const index = config.src.lastIndexOf('.');
        const stub = config.src.substring(0, index);
        const suffix = config.src.substring(index, config.src.length);
        const image = `${stub}-w_${config.width}${suffix}`;

        return imageUrl(image);
      } else {
        return imageUrl(config.src);
      }
    }

    const transformation = config.loaderParams?.['transformations'] as ImageOptimisePreset | undefined;
    return optimiseService.getFromPreset(config.src, transformation);
  };
};

export function provideCustomImageLoader(breakpoints: number[] = [576, 640, 768, 1024, 1280, 1536]) {
  return [
    {
      provide: IMAGE_LOADER,
      deps: [appendToRmaStaticImageUrl, ImageOptimiseService],
      useFactory: imageUrlFactory,
    },
    {
      provide: IMAGE_CONFIG,
      useValue: {
        breakpoints,
      },
    },
  ];
}
